module.exports = __webpack_public_path__ + "img/br.8f1ef85e.svg";